import get from 'lodash.get';
import { createSelector } from 'reselect';
import { getPageFirstCardData, getPageFeatureFlags } from 'src/universal/redux/page';

export const getInFlowAlertBannerData = createSelector(
  [getPageFirstCardData, getPageFeatureFlags],
  (card = {}, { hideInFlowAlertBanner = false }) => {
    const title = get(card, 'inFlowAlertBanner.title') || '';
    const subTitle = get(card, 'inFlowAlertBanner.subTitle') || '';
    const hasAlertData = !!(title && subTitle);
    return {
      primaryHeadline: title,
      secondaryHeadline: subTitle,
      shouldRender: !hideInFlowAlertBanner && hasAlertData
    };
  }
);
